<template>
  <div class="overflow-hidden">
    <section class="cp-page py-4">
      <header-help :is-loading="isLoading"></header-help>
      
      <!-- Background animated orbs using Stella brand colors -->
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container position-relative my-auto" style="z-index: 1;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="cp-content-card p-4 p-md-5 text-center position-relative">
              
              <!-- Close Button -->
              <button type="button" class="btn-close-tip position-absolute" aria-label="Close" @click="closeTip()">
                <i class="fa fa-times text-white font-size-14"></i>
              </button>
              
              <div class="d-inline-flex align-items-center justify-content-center mb-3" 
                   style="width: 60px; height: 60px; border-radius: 50%; background: rgba(243,218,107,0.15); color: #F3DA6B; font-size: 24px; box-shadow: 0 0 25px rgba(243,218,107,0.3);">
                <i class="fa fa-heart"></i>
              </div>

              <h3 class="text-white font-weight-700 mb-1">Support {{ invitee.name }}</h3>
              <p class="text-white-50 font-size-14 mb-3">
                Send an optional tip along with a personal note
              </p>

              <global-message></global-message>

              <!-- Interactive Tip Pills Selector -->
              <div class="tip-pill-container mb-3">
                <div class="tip-pill" :class="{ active: isActive(5) }" @click="selectedTip(5)">
                  $5
                </div>
                <div class="tip-pill" :class="{ active: isActive(10) }" @click="selectedTip(10)">
                  $10
                </div>
                <div class="tip-pill" :class="{ active: isActive(15) }" @click="selectedTip(15)">
                  $15
                </div>
                <div class="tip-pill" :class="{ active: isActive(25) }" @click="selectedTip(25)">
                  $25
                </div>
                <div class="tip-pill" :class="{ active: isActive(50) }" @click="selectedTip(50)">
                  $50
                </div>
              </div>

              <!-- Custom Amount Input -->
              <div class="text-start mb-3">
                <label class="text-white font-size-13 mb-2 font-weight-500">Custom Amount</label>
                <span class="danger ms-2" v-if="isRequired('amount')">Amount is required</span>
                <div class="position-relative">
                  <span class="position-absolute text-white-50 font-size-15 font-weight-500" style="left: 16px; top: 50%; transform: translateY(-50%); pointer-events: none; z-index: 2;">$</span>
                  <input type="number" min="1"
                         class="form-control cp-input tip-amount-input"
                         placeholder="Enter amount"
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                         v-model="tip.amount">
                </div>
              </div>

              <!-- Personal Note -->
              <div class="text-start mb-4">
                <label class="text-white font-size-13 mb-2 font-weight-500">Personal Note (Optional)</label>
                <textarea
                  class="form-control cp-input"
                  rows="3"
                  placeholder="Say something nice to creator..."
                  v-model="tip.message"></textarea>
              </div>

              <!-- Actions -->
              <button type="button"
                      class="cp-btn-primary w-100 mb-2"
                      @click="donate()">
                <i class="fa fa-paper-plane me-2"></i> Send ${{ tip.amount || 10 }} Tip
              </button>

              <button type="button"
                      class="cp-btn-ghost w-100"
                      v-if="!$route.query.donate"
                      @click="skip()">
                Skip to Messages <i class="fa fa-arrow-right ms-1"></i>
              </button>

            </div>
          </div>
        </div>
      </div>
    </section>

    <stripe-checkout
      v-if="isShow"
      ref="checkoutRef"
      :pk="pk"
      :sessionId="sessionId"
    ></stripe-checkout>
  </div>
</template>

<script>
import {StripeCheckout} from '@vue-stripe/vue-stripe';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";
import {mapActions, mapGetters} from 'vuex';
import {required} from "vuelidate/lib/validators";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {SERVICE_SUBSCRIPTION} from "@/properties/micro-service";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import titleMixin from "../../../../mixin/title-mixin";

export default {
  name: 'TipPayment',
  title: 'Tip Payment',
  mixins: [customerAccountMixin, titleMixin],
  components: {GlobalMessage, StripeCheckout, LoadingModal, HeaderHelp},
  data() {
    return {
      tip: {
        amount: 10,
        message: ''
      },
      invitee: {name: ''},
      isSubmit: false,
      isShow: false,
      pk: null,
      sessionId: null
    }
  },
  validations: {
    tip: {
      amount: {required},
    },
  },
  created() {
    this.invitee = this.getInvitee;
    if (this.$route.query.amount) {
      this.tip.amount = this.$route.query.amount;
    }
  },
  methods: {
    ...mapActions(['pushGlobalError', 'setMessage']),
    ...mapGetters(['getCreatePlatform']),
    isRequired(attrib) {
      return this.isSubmit && !this.$v.tip[attrib].required;
    },
    selectedTip(value) {
      this.tip.amount = value;
    },
    isActive(value) {
      let tip = parseFloat(this.tip.amount);
      return tip === value;
    },
    skip() {
      let donate = this.$route.query.donate;
      if (this.getCreatePlatform || donate) {
        this.showCustomerContent();
      } else {
        this.$router.replace({name: 'MessageCta'});
      }
    },
    closeTip() {
      let donate = this.$route.query.donate;
      if (donate) {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          this.showCustomerContent();
        }
      } else {
        this.skip();
      }
    },
    donate() {
      this.isSubmit = true;
      this.$v.$touch();

      if (!this.tip.amount || this.tip.amount < 1) {
        return;
      }

      if (this.$v.$invalid) {
        return;
      }

      this.tip.influencer = {id: this.invitee.id};
      this.tip.customer = {id: this.getUser.id};
      let url = `${SERVICE_SUBSCRIPTION}/api/v1/customers/${this.getUser.id}/tip`;
      this.postData(url, this.tip, (tip) => {
        this.tip = tip;
        localStorage.setItem('tip', tip.amount);
        let stripeCheckoutData = tip.transaction;
        let otherData = stripeCheckoutData.othersData;
        let status = stripeCheckoutData.status;
        this.pk = otherData.pk;
        this.sessionId = stripeCheckoutData.req.id;

        if (status === 'Success') {
          let donate = this.$route.query.donate;
          if (this.getCreatePlatform || donate) {
            this.$router.push({ name: 'TipComplete', query: { donate: true } });
           } else {
            this.$router.replace({name: 'TipComplete'});
          }
        } else if (status === 'InProgress') {
          this.pushGlobalError(otherData.offlineCheckoutError);
          setTimeout(() => {
            this.isShow = true;
            this.$nextTick(() => {
              this.$refs.checkoutRef.redirectToCheckout();
            });
          }, 2000);
        }
      });
    }
  }
}
</script>

<style scoped>
.tip-amount-input {
  padding-left: 36px !important;
}

.btn-close-tip {
  top: 16px;
  right: 16px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  padding: 0;
}

.btn-close-tip:hover,
.btn-close-tip:active {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.08);
}
</style>
